import React, { useEffect } from 'react';
import { redirectToLoginPage } from 'src/helpers/auth/openid/openid-manager';
import { logger } from '../../application/logging/logging';
import styles from './login.module.scss';
import { AnimationProps, Loading } from 'uikit/suspense/Loading';
import { Loader as animationData } from 'assets/animations/loadin_book';
import Lottie from 'react-lottie-player';

const animation: AnimationProps = {
  size: 88,
  element: <Lottie animationData={animationData} style={{ width: 88, height: 88 }} play={true} loop={true} />,
};

export const LoginPage: React.FC = () => {
  useEffect(() => {
    redirectToLoginPage().catch((e) => logger().error(e));
  }, []);

  return <Loading animation={animation} loading containerClassName={styles.loginContainer} testId={'login-page'} />;
};
